// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2l1WB","inner":"Form_inner__Eg-0S","range":"Form_range__1UUum","name":"Form_name__3kcmQ","actions":"Form_actions__175g_"};